import React from 'react';
import { FontPack } from '../../../../../../types/working-model';
import Helmet from 'react-helmet';
import classNames from 'classnames';
interface Props {
	font: FontPack;
	onClick: (font: FontPack) => void;
	selected: boolean;
}

export default function Font(props: Props): JSX.Element {
	const { font, onClick, selected } = props;
	return (
		<div
			id={`font-${font.font_pack}`}
			className={classNames('font-container', { selected })}
			onClick={() => onClick(font)}
		>
			<div className={'font-active'}>
				<div className="radio">
					<span />
				</div>
			</div>
			<div className="font">
				<h6 style={{ fontFamily: `var(--var-head), sans-serif` }}>
					{font.title}
				</h6>
				<p style={{ fontFamily: `var(--var-body), sans-serif` }}>
					{font.description}
				</p>
			</div>

			<FontHelmet font={font} />
		</div>
	);
}

export function FontHelmet({ font }: { font: FontPack }): JSX.Element {
	return (
		<Helmet>
			<style>{`

					${
						font.heading_url.includes('fonts.googleapis.com')
							? `
						@import url(${font.heading_url});`
							: `@font-face {
							font-family: "${font.heading_name}";
							src: url(${font.heading_url});
						}`
					}
						
					${
						font.body_url.includes('fonts.googleapis.com')
							? `
						@import url(${font.body_url});`
							: `
						@font-face {
							font-family: "${font.body_name}";
							src: url(${font.body_url});
						}`
					}
					

					#font-${font.font_pack} {
						--var-head: "${font.heading_name}", sans-serif;
						--var-body: "${font.body_name}", sans-serif;
					}
				`}</style>
		</Helmet>
	);
}
